// removed by extract-text-webpack-plugin
module.exports = {"Hyperlink":"Hyperlink","Hyperlink__text-pc":"Hyperlink__text-pc","Hyperlink__text-mb":"Hyperlink__text-mb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/hyperlink/styles.css
// module id = 690
// module chunks = 0 1